import { Nullable } from '@dxb-web-ui-framework/common/types';
import {
  APIGatewayResponse,
  APIGatewayResponseDataHeader,
} from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';

export enum RoutingTransferTypes {
  INTERNAL_SAME_CURRENCY = 'INTERNAL_SAME_CURRENCY',
  INTERNAL_OTHER_CURRENCY = 'INTERNAL_OTHER_CURRENCY',
  EXTERNAL_SAME_CURRENCY = 'EXTERNAL_SAME_CURRENCY',
  EXTERNAL_OTHER_CURRENCY = 'EXTERNAL_OTHER_CURRENCY',
  INTRABANK_SAME_CURRENCY = 'INTRABANK_SAME_CURRENCY',
  INTRABANK_OTHER_CURRENCY = 'INTRABANK_OTHER_CURRENCY',
  CORPORATE_INTERNAL_OTHER_CURRENCY = 'CORPORATE_INTERNAL_OTHER_CURRENCY',
  CORPORATE_INTERNAL_SAME_CURRENCY = 'CORPORATE_INTERNAL_SAME_CURRENCY',
  EXTERNAL_UNKNOWN_BANK_SAME_CURRENCY = 'EXTERNAL_UNKNOWN_BANK_SAME_CURRENCY',
  EXTERNAL_UNKNOWN_BANK_OTHER_CURRENCY = 'EXTERNAL_UNKNOWN_BANK_OTHER_CURRENCY',
  PSD2_EXTERNAL_SAME_CURRENCY = 'PSD2_EXTERNAL_SAME_CURRENCY',
}

export type RoutingResponseBody = {
  transferType: RoutingTransferTypes;
  iban: string;
  bic: string;
  creditorFullName: string;
  creditorFullNameUnMasked: string | null;
  countrySerialNumber: Nullable<number>;
  bankCountry: string;
  bankName: string;
  bankCity: string;
  bankAddress: string;
  appTransactionId: number;
  debitCurrency: number;
  sortCode: Nullable<string>;
  ecommbx: boolean;
};

class RoutingResponseDTO implements APIGatewayResponse<RoutingResponseBody> {
  headers: APIGatewayResponseDataHeader[];
  body: Nullable<RoutingResponseBody>;

  constructor(headers: APIGatewayResponseDataHeader[], body: Nullable<RoutingResponseBody>) {
    this.headers = headers;
    this.body = body;
  }
}

export { RoutingResponseDTO };
